var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "privacy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.115,
    height: 22.071,
    viewBox: "0 0 16.115 22.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M172.561,296.171a.647.647,0,0,0,.647-.647v-2.678a.647.647,0,1,0-1.293,0v2.678A.647.647,0,0,0,172.561,296.171Zm0,0",
    transform: "translate(-164.503 -279.603)",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M15.468,7.092h-3.06V3.943A4.166,4.166,0,0,0,8.057,0a4.166,4.166,0,0,0-4.35,3.943v3.15H.647A.647.647,0,0,0,0,7.739v8.269a6.069,6.069,0,0,0,6.062,6.062h3.99a6.069,6.069,0,0,0,6.062-6.062V7.739A.647.647,0,0,0,15.468,7.092ZM5,3.943A2.878,2.878,0,0,1,8.057,1.293a2.879,2.879,0,0,1,3.057,2.649v3.15H5Zm9.821,12.066a4.775,4.775,0,0,1-4.769,4.769H6.062a4.775,4.775,0,0,1-4.769-4.769V8.386H14.821Zm0,0",
    fill: "gray"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.dad0745fb9c5e7be6f5ba197dccd8edf.svg";
export { ForwardRef as ReactComponent };